<template>
  <BasePanelWithHeader headerText="Users">
    <BaseServerSyncDataTable
      :headers="filteredHeaders"
      :items="mappedUsers"
      :searchText="searchText"
      :search="true"
      itemKey="Id"
      :loading="loading"
      :searchTotal="searchTotal"
      :searchSortBy.sync="searchSortBy"
      :searchDescending.sync="searchDescending"
      :searchPage.sync="searchPage"
      :searchRowsPerPage.sync="searchRowsPerPage"
    >
      <!-- //templateTodo: uncomment use custom search params-->
      <template v-slot:searchParams>
        <UserParams></UserParams>
      </template>
      <template v-slot:item.edit="{ item }">
        <BaseTooltipButton
          small
          @click="$refs.userForm.editUser(item)"
          iconColor="primary"
          icon="mdi-pencil"
          >Edit User
        </BaseTooltipButton>
      </template>
      <template v-slot:item.delete="{ item }">
        <BaseTooltipButton
          small
          @click="$refs.userDelete.deleteConfirm(item)"
          iconColor="primary"
          icon="mdi-delete"
          >Delete User
        </BaseTooltipButton>
      </template>
    </BaseServerSyncDataTable>
    <BaseDeleteConfirm
      ref="userDelete"
      :delete="deleteUser"
      @refresh="searchUsers"
    >
      Are you sure you want to delete this user?
    </BaseDeleteConfirm>
    <UserDialogForm ref="userForm" @refresh="searchUsers"> </UserDialogForm>
  </BasePanelWithHeader>
</template>

<script>
import { get, sync, commit, call } from 'vuex-pathify'
//templateTodo: uncomment use custom search params
import UserParams from '@components/search/UserParams'
import UserDialogForm from '@components/form/add-edit/UserDialog'

export default {
  name: 'UserSearchTable',
  components: {
    //templateTodo: uncomment use custom search params
    UserParams,
    UserDialogForm
  },
  data: () => ({}),
  created() {
    this.searchUsers()
    this.searchAgencyId = []
  },
  computed: {
    ...get('user', ['users', 'loading']),
    ...sync('user', [
      'searchTotal',
      'searchPage',
      'searchSortBy',
      'searchDescending',
      'searchRowsPerPage',
      'searchText',
      'searchShowInactive',
      'searchAgencyId',
    ]),
    headers() {
      return [
        {
          text: '',
          align: 'center',
          value: 'edit',
          visible: true,
          sortable: false,
        },
        {
          text: 'ID',
          align: 'center',
          sortable: true,
          value: 'ID',
          visible: false,
        },
        {
          text: 'First Name',
          align: 'center',
          sortable: true,
          value: 'FirstName',
          visible: true,
        },
        {
          text: 'Last Name',
          align: 'center',
          sortable: true,
          value: 'LastName',
          visible: true,
        },
        {
          text: 'Email',
          align: 'center',
          sortable: true,
          value: 'Email',
          visible: true,
        },
        {
          text: 'Roles',
          align: 'center',
          sortable: true,
          value: 'roles',
          visible: true,
        },
        {
          text: 'Is Active',
          align: 'center',
          sortable: true,
          value: 'IsActive',
          visible: this.searchShowInactive,
        },
        {
          text: 'Office Phone',
          align: 'center',
          sortable: true,
          value: 'OfficePhone',
          visible: false,
        },
        {
          text: 'Mobile Phone',
          align: 'center',
          sortable: true,
          value: 'MobilePhone',
          visible: false,
        },
        {
          text: 'Agency',
          align: 'center',
          sortable: true,
          value: 'Agency',
          visible: false,
        },
        {
          text: 'Division',
          align: 'center',
          sortable: true,
          value: 'Division',
          visible: false,
        },
        {
          text: '',
          align: 'center',
          value: 'delete',
          visible: false,
          sortable: false,
        },
      ]
    },
    filteredHeaders() {
      return this.headers.filter((h) => h.visible)
    },
        mappedUsers() {
      return this.users
        .map((item) => {
          return {
            ...item,
            roles: item.Roles.map((i) => i.Description).join(', '),
          }
        })
    },
  },
  methods: {
        ...call('user', ['deleteUser', 'searchUsers']),
    // searchUsers: call('user/searchUsers'),
  },
}
</script>

<style></style>
